export * from './base.service';
export * from './dialog.service';
export * from './authentication.service';
export * from './loading.service';
export * from './notificacao.service';
export * from './translate.service';
export * from './devedor.service';
export * from './acordo.service';
export * from './telefone.service';
export * from './endereco.service';
export * from './email.service';
export * from './router.service';
export * from './logSistema.service';
export * from './pagamento.service';
export * from './boleto.service';





// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/services/index.ts